import type { PropertyValue } from 'state/data/dataState';
import type { SemNode } from 'types/data/semNode';

/**
 * A helper function that recursively finds a node and **updates** only specified properties.
 * It traverses the node graph, and when it finds the target node, it merges
 * the new properties into the existing ones rather than replacing the whole object.
 */
export const deepUpdate = (rawNodes: SemNode[], nodeId: string, propertiesToUpdate: Record<string, PropertyValue>) => {
  rawNodes.forEach((node) => {
    if (node.Id === nodeId) {
      // Merge the new properties into the existing ones.
      Object.assign(node.Properties, propertiesToUpdate);
      return;
    }
    if (node.Edges) {
      // Recursively call deepUpdate for all connected nodes.
      Object.keys(node.Edges).forEach((edgeKey) => {
        const targetNodes = node.Edges[edgeKey].map((edge) => edge.Target);
        deepUpdate(targetNodes, nodeId, propertiesToUpdate);
      });
    }
  });
};
